import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const calculateCommission = (
  annualValue: number | null,
  percentage: number | null
): number => {
  const value = annualValue || 0;
  const percent = percentage || 30;
  return Math.round(value * (percent / 100));
};
